function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icons8-angularjs",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M51.986,3,4,19.7l7.583,62.175,40.453,21.988L92.7,81.577,100.279,19.4Z",
  transform: "translate(-4 -3)",
  fill: "none",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M22.171,71.186l6.377-13.738h26.5L61.43,71.186H71.6L41.8,7,12,71.186Z",
  transform: "translate(6.339 2.169)",
  fill: "none",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M30.074,16.5l9,19.513h-18Z",
  transform: "translate(18.066 14.447)",
  fill: "none",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.279,
    height: 102.864,
    viewBox: "0 0 98.279 102.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/Angular.2e3f01cd.svg";
export { ForwardRef as ReactComponent };